import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { AvailableModules } from 'generated/featureDefinitions'
import { CheckModuleAvailabilityForShiftsDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import type LogicOperatorForm from 'modules/core/components/MultiFilters/Forms/LogicOperatorForm'
import type MultiFilterForm from 'modules/core/components/MultiFilters/Forms/MultiFilterForm'
import { useQuery } from 'modules/core/hooks/useQuery'

import NewThemeHeaderViewNavigator from 'modules/shift_management/components/ShiftManagement/Content/NewThemeHeaderViewNavigator'
import { useEnabledFeatures } from 'modules/shift_management/hooks/useEnabledFeatures'
import { usePermissions } from 'modules/shift_management/hooks/usePermissions'

import CommandsFilterBar from './CommandsFilterBar'
import ShiftActionsBar from './ShiftActionsBar'
import * as styles from './index.vanilla.css'

interface Props {
  filters: MultiFilterForm[]
  logicOperator: LogicOperatorForm
  onAddFilter: () => void
  onRemoveFilter: (index: number) => void
  onApplyFilters: (defaultFilter?: MultiFilterForm[]) => void
  onCancel: () => void
  onResetFilters: () => void
  setShowCoverageSection: (showCoverageSection: boolean) => void
  showCoverageSection?: boolean
  hasNoneShiftManagementPlanning?: boolean
}

const TableHeader = ({
  filters,
  logicOperator,
  onAddFilter,
  onRemoveFilter,
  onApplyFilters,
  onCancel,
  onResetFilters,
  setShowCoverageSection,
  showCoverageSection,
  hasNoneShiftManagementPlanning = false,
}: Props) => {
  // TODO: Remove when Factorial One is the default theme
  // We have introduced more changes than the expected one in this first phase (ResponsePage and tabs)
  const [{ canManageShifts }] = usePermissions()
  const [{ hasFeatureFlag }] = useEnabledFeatures()

  const newEntryFlowEnabled = hasFeatureFlag('dev_shift_management_autoscheduler_entry_flow')

  const { data: timeOffModuleAvailability } = useQuery(CheckModuleAvailabilityForShiftsDocument, {
    variables: {
      moduleId: AvailableModules.timeoff,
    },
  })

  const hasTimeOffModule = !!timeOffModuleAvailability?.companies.moduleAvailability?.available

  const containerRef = React.useRef<HTMLDivElement>(null)

  return (
    <Box
      background={newEntryFlowEnabled ? 'white' : 'grey100'}
      flexDirection="column"
      className={styles.header}
      ref={containerRef}
    >
      <Box flexDirection="row" paddingBottom="s16" paddingTop="s8" paddingX="s24">
        <CommandsFilterBar
          filters={filters}
          logicOperator={logicOperator}
          onAddFilter={onAddFilter}
          onRemoveFilter={onRemoveFilter}
          onApplyFilters={onApplyFilters}
          onCancel={onCancel}
          onResetFilters={onResetFilters}
          disabled={hasNoneShiftManagementPlanning}
          canManageShifts={canManageShifts}
          hasNoneShiftManagementPlanning={hasNoneShiftManagementPlanning}
        />
        <NewThemeHeaderViewNavigator
          hasNoneShiftManagementPlanning={hasNoneShiftManagementPlanning}
        />
        {/* This Box is used to center the NewThemeHeaderViewNavigator when can't manage shifts */}
        {!canManageShifts && <Box></Box>}
        {canManageShifts && (
          <ShiftActionsBar
            hasNoneShiftManagementPlanning={hasNoneShiftManagementPlanning}
            disabled={hasNoneShiftManagementPlanning}
            setShowCoverageSection={setShowCoverageSection}
            showCoverageSection={showCoverageSection}
            hasTimeOffModule={hasTimeOffModule}
          />
        )}
      </Box>
    </Box>
  )
}

export default observer(TableHeader)
